import { ThemeColor, PanelColor } from "../props";
import { themeBackgroundStyles, themeForegroundStyles, themeBorderStyles, themeTextStyles } from "./theme";
import { panelBackgroundStyles, panelForegroundStyles, panelBorderStyles } from "./panel";
import { cn } from "./cn";

export function getBackgroundStyles(color: ThemeColor | PanelColor): string {
  if (Object.values(ThemeColor).includes(color as ThemeColor)) {
    return themeBackgroundStyles[color as ThemeColor];
  }
  if (Object.values(PanelColor).includes(color as PanelColor)) {
    return panelBackgroundStyles[color as PanelColor];
  }
  return "";
}

export function getForegroundStyles(color: ThemeColor | PanelColor): string {
  if (Object.values(ThemeColor).includes(color as ThemeColor)) {
    return themeForegroundStyles[color as ThemeColor];
  }
  if (Object.values(PanelColor).includes(color as PanelColor)) {
    return panelForegroundStyles[color as PanelColor];
  }
  return "";
}

export function getBorderStyles(color: ThemeColor | PanelColor): string {
  if (Object.values(ThemeColor).includes(color as ThemeColor)) {
    return themeBorderStyles[color as ThemeColor];
  }
  if (Object.values(PanelColor).includes(color as PanelColor)) {
    return panelBorderStyles[color as PanelColor];
  }
  return "";
}

export function getSolidBackgroundStyles(color: ThemeColor): string {
  return cn(themeTextStyles[color], "bg-current");
}

export function isPanelColor(color: ThemeColor | PanelColor): boolean {
  return Object.values(PanelColor).includes(color as PanelColor);
}

export function incPanelColorLevel(color: PanelColor, offset: number = 1): PanelColor {
  const levels = Object.values(PanelColor);
  const currentIndex = levels.indexOf(color);
  if (currentIndex === -1) return color;
  const newIndex = currentIndex + offset;
  if (newIndex < 0) return levels[0];
  if (newIndex >= levels.length) return levels[levels.length - 1];
  return levels[newIndex];
}

export function getDisabledStyles(): string {
  return "opacity-50 cursor-not-allowed";
}

export const springAnimationClass = "duration-350 [transition-timing-function:cubic-bezier(0.3,1.85,0.6,1)]";
export const normalAnimationClass = "duration-250 ease-out";
